export var MessagesCategoryType;
(function (MessagesCategoryType) {
    MessagesCategoryType["SentMessages"] = "sentMessages";
    MessagesCategoryType["ReceivedMessages"] = "receivedMessages";
    MessagesCategoryType["TotalMessages"] = "totalMessages";
    MessagesCategoryType["ActiveMessages"] = "activeMessages";
    MessagesCategoryType["ActiveMessagesPerDomain"] = "activeMessagesPerDomain";
})(MessagesCategoryType || (MessagesCategoryType = {}));
export var UsersCategoryType;
(function (UsersCategoryType) {
    UsersCategoryType["UniqueUsers"] = "uniqueUsers";
    UsersCategoryType["ActiveUsers"] = "activeUsers";
    UsersCategoryType["EngagedUsers"] = "engagedUsers";
    UsersCategoryType["AverageInteractionUsers"] = "averageInteractionUsers";
    UsersCategoryType["TotalUsers"] = "totalUsers";
})(UsersCategoryType || (UsersCategoryType = {}));
